/**
 * Created by anthony on 7/3/14.
 */
var reminderModel = angular.module('reminderModel', ['appModel']);
reminderModel.factory('ReminderModelFactory', function(ApplicationService, authServiceFactory, AppModelFactory){
    var ReminderModel = function(){
        this.endpoint = "/reminder";
        this.dataProperty = "reminders";
        this.primaryKey = "recordID";
    }
    ReminderModel.prototype = new AppModelFactory();
    ReminderModel.prototype.parent = AppModelFactory.prototype;
    ReminderModel.prototype.resolveData = function()
    {
        var parent = this;
        this.parent.data = ApplicationService.getAwardData()['reminders'];
    }
    ReminderModel.prototype.new = function()
    {
        var dt = new Date();
        var reminder = {applicationID: ApplicationService.getAwardData().app[0].applicationID, schoolID: authServiceFactory.getAuth().schoolID, reminder: '', year: dt.getDateMySqlFormatted()};
        return (ApplicationService.getAwardData()['reminders'].push(reminder))-1;
    }
    return ReminderModel;
});

reminderModel.service('ReminderModelService', function(ReminderModelFactory){
    var reminderModel = new ReminderModelFactory();
    return reminderModel;
});
